export default {
  serverURL: 'https://samsblogbackend.herokuapp.com/'
}
